import FallBackIcon from '$icons/fallback-no-image.svg';

export default function PlaceholderImage({ size }: { size?: number }) {
    return <FallBackIcon width={size ?? 130} height={size ?? 130} />;
}
